/**
 * 首页公告
 */
import React, { FC, useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import { IonSlides, IonSlide } from '@ionic/react'
import { advertMobx } from '@mobxStore'
import { ddayjs, classNames } from '@dt/fe-utils'
import languageMobx from '@mobx/app/language.mobx'
import './index.scss'

interface IProps {
  type: TAdvertCaseType;
  isOnly?: boolean; // 首页广告是否隐藏了，隐藏就需要吧公告制顶
}

const Notice: FC<IProps> = ({ type = 'home', isOnly = false }) => {
  const { advertInfo } = advertMobx
  const [isLoaded, setIsLoaded] = useState(false)
  const isTop = useMemo(() => languageMobx.languageList.length > 1, [languageMobx.languageList])

  const noticeArr = useMemo(() => {
    // 当前时间字符串
    const nowDate = ddayjs().format('YYYY-MM-DD')
    const nowTime = ddayjs().format('HH:mm')
    const noticeAds = advertInfo[type]?.noticeAds || []
    const filterNotice = noticeAds.filter(ad => {
      let { showDate, showTime, showDateType, title } = ad
      if (!showDateType) return true
      // 当前时间在广告设置的时间内
      return title && showDate.some(({ start, end }, index) => {
        return start <= nowDate && end >= nowDate && (showTime[index].start <= nowTime && showTime[index].end >= nowTime)
      })
    })
    if (filterNotice.length) {
      return filterNotice
    } else {
      return []
    }
  }, [advertInfo[type]])
  // 轮播参数
  const slideOpts = {
    initialSlide: 0,
    speed: 300,
    autoplay: noticeArr.length > 1 ? {
      delay: advertInfo[type].noticeAdsInfo?.interval === undefined ? 3000 : advertInfo[type].noticeAdsInfo?.interval,
      disableOnInteraction: false
    } : false,
    loop: noticeArr.length > 1,
    direction: 'vertical'
  }

  return (
    type === 'home' && !!noticeArr.length && (
      <div className={classNames('ad-notice-container', { position: isOnly, top: isOnly && isTop })}>
        <IonSlides
          id={`advertElement${type}notice`}
          className='advertElement-notice-container'
          options={slideOpts}
          pager={false}
          onIonSlideTouchStart={(e) => {
            if (isLoaded === false) {
              e.stopPropagation()
              return false
            }
          }}
          onIonSlidesDidLoad={() => {
            setIsLoaded(true)
          }}
        >
          {
            noticeArr.map((item, index) => (
              <IonSlide
                key={index}
                className='advertElement-notice-item'
                data-cypid={`noticeItem_${index}`}
                style={{ color: advertInfo[type].noticeAdsInfo?.color || '#161616', fontSize: advertInfo[type].noticeAdsInfo?.fontSize || 14 }}
                onClick={() => {
                  if (item.url) {
                    location.href = item.url
                  }
                }}
              >
                <span>{item.title}</span>
                <i className='iconfont icon-chevron-right'></i>
              </IonSlide>
            ))
          }
        </IonSlides>
      </div>
    )
  )
}

export default observer(Notice)
